import {Text} from '@chakra-ui/react';

import {TranslationKeys} from '../../translations';
import {OrderTotalListItem} from './order-total-details/components';
import {Price} from './price';

interface SmallOrderFeeRowProps {
  fee?: number;
  onOpenInfo: () => void;
  t: (key: TranslationKeys) => string;
}

export function SmallOrderFeeRow({fee, onOpenInfo, t}: SmallOrderFeeRowProps) {
  if (!fee) return null;

  return (
    <OrderTotalListItem boxProps={{borderBottom: '1px solid #E6E6E6', textAlign: 'left'}} title="">
      <Text flex={1} as="span" fontWeight="500" fontSize={['14px', '18px']} textAlign="left" onClick={onOpenInfo}>
        {t('smallOrder') + ' ⓘ'}
      </Text>

      <Price value={fee} priceProps={{fontWeight: '500'}} />
    </OrderTotalListItem>
  );
}
